import React from 'react';

export function CapabilityCard({ icon: Icon, title, description, iconBg }) {
  return (
    <article className="group flex h-full gap-4 rounded-xl border border-ink-200 bg-white p-5 shadow-xs transition-all duration-200 hover:border-brand-200 hover:shadow-md">
      <span className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-lg ${iconBg}`}>
        <Icon className="h-5 w-5" aria-hidden="true" />
      </span>
      <div className="min-w-0">
        <h3 className="text-base font-semibold text-ink-900 leading-snug">{title}</h3>
        <p className="mt-2 text-sm leading-6 text-ink-600">{description}</p>
      </div>
    </article>
  );
}

export function CapabilityCardFeatured({ icon: Icon, title, description, iconBg, borderAccent }) {
  return (
    <article
      className={`rounded-xl border border-ink-200 bg-white p-6 sm:p-8 shadow-xs border-l-4 ${borderAccent}`}
    >
      <div className="flex flex-col gap-5 lg:flex-row lg:items-start lg:gap-8">
        <div className="flex items-start gap-4 lg:max-w-sm shrink-0">
          <span className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-xl ${iconBg}`}>
            <Icon className="h-5 w-5" aria-hidden="true" />
          </span>
          <h3 className="text-lg font-semibold text-ink-900 leading-snug pt-2">{title}</h3>
        </div>
        <p className="text-sm leading-7 text-ink-600 lg:pt-2">{description}</p>
      </div>
    </article>
  );
}

export function CapabilityGroup({ label, accent, columns, children }) {
  return (
    <div>
      {label && (
        <p
          className={`mb-5 inline-flex items-center rounded-full px-3 py-1 text-xs font-semibold uppercase tracking-wide ${accent}`}
        >
          {label}
        </p>
      )}
      <div className={`grid gap-4 ${columns || 'grid-cols-1 md:grid-cols-2'}`}>{children}</div>
    </div>
  );
}

export function renderCapabilityItems(items, { iconBg, borderAccent }) {
  return items.map((item) => {
    const Card = item.featured ? CapabilityCardFeatured : CapabilityCard;
    const wrapperClass = item.featured ? 'md:col-span-2' : undefined;

    return (
      <div key={item.title} className={wrapperClass}>
        <Card
          icon={item.icon}
          title={item.title}
          description={item.description}
          iconBg={item.iconBg || iconBg}
          borderAccent={borderAccent}
        />
      </div>
    );
  });
}
